import React, { useEffect, useState } from 'react'
import './SliderBlockContent.scss'
import classNames from 'classnames'
import {findIndex} from 'lodash'
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight  } from "react-icons/md";

function SliderBlockContent({items =[], activeItem}) {
  console.log("🚀 ~ SliderBlockContent ~ activeItem:", activeItem)
  console.log("🚀 ~ SliderBlockContent ~ items:", items)
  const [active, setActive] = useState(items[0] ? items[0] : {})
  useEffect(() => {
    if(activeItem){
      setActive(activeItem)
    } else {
      setActive(items[0] ? items[0] : {})
    }
    
  }, [activeItem, items])


  const indexFind = findIndex(items, ['id', active.id])

  const nextSlide = items[indexFind + 1]
  const prevSlide = items[indexFind - 1]

  return (
    <div className='SliderBlockContent'>
      {items.map((_i, index) => <div className={classNames('item-img', {active: index == indexFind})} key={'img_' + index}>
        <img src={_i.src} />
      </div>)}
      {Boolean(prevSlide) && <div className='btn_left' onClick={() => {
        if(prevSlide){
          setActive(prevSlide)
        }
      }}>
        <div className='btn_icon'>
          <MdOutlineKeyboardArrowLeft size={50}  />
        </div>
      </div>}
      {Boolean(nextSlide) && <div className='btn_right' onClick={() => {
        if(nextSlide){
          setActive(nextSlide)
        }
      }}>
        <div className='btn_icon'>
          <MdOutlineKeyboardArrowRight size={50}  />
        </div>
      </div>}
    </div>
  )
}

export default SliderBlockContent


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/SliderVIew/components/SliderBlockContent/SliderBlockContent.jsx